// Format:
// username: passoword
export const LOGIN_CREDENTIALS = {
  lag1: "passord1",
  lag2: "passord2",
};

export const ROUTES = {
  home: "/",
  login: "/login",
  leaderboard: "/leaderboard",
};
